export default "__VITE_ASSET__D2vMBzNP__"